import React from 'react';
import { cn } from 'utils';

const classes = {
  container: 'odin-flex odin-gap-x-6',
  label: 'odin-w-1/2 odin-text-sm odin-font-medium',
  value: 'odin-w-1/2 odin-text-sm odin-text-gray-600',
};

export type CardItemProps = {
  label: React.ReactNode;
  value: React.ReactNode;
  valueClassName?: string;
};

export function CardItem(props: CardItemProps): React.ReactElement {
  const { label, value, valueClassName } = props;
  return (
    <div className={classes.container}>
      <div className={classes.label}>{label}</div>
      <div className={cn(classes.value, valueClassName)}>{value}</div>
    </div>
  );
}
